import styled from 'styled-components';
import { zIndex } from 'tokens';

// Corner container positions
export const TopRight = styled.div`
	position: absolute;
	top: 14px;
	right: 14px;
	z-index: ${zIndex.island};
	display: flex;
	align-items: center;
	gap: 0;
`;

export const BottomRight = styled.div`
	position: absolute;
	bottom: 14px;
	right: 14px;
	z-index: ${zIndex.island};
	display: flex;
	align-items: center;
	gap: 0;
`;

// Bottom-left island, panel-aware: sits just inside the open canvas area
export const BottomLeft = styled.div<{ left: number }>`
	position: absolute;
	bottom: 14px;
	left: ${({ left }) => left + 14}px;
	z-index: ${zIndex.island};
	display: flex;
	align-items: center;
	gap: 0;
`;

export const BottomCenter = styled.div<{ left: number }>`
	position: absolute;
	bottom: 14px;
	left: ${({ left }) => left}px;
	transform: translateX(-50%);
	z-index: ${zIndex.island};
	display: flex;
	align-items: center;
	gap: 0;
`;

export const TopCenter = styled.div`
	position: absolute;
	top: 14px;
	left: 50%;
	transform: translateX(-50%);
	z-index: ${zIndex.island};
`;

// Button types for pill-shaped button groups
export enum ButtonType {
	LEFT = 'LEFT',
	RIGHT = 'RIGHT',
	SINGLE = 'SINGLE',
	CENTER = 'CENTER',
}

// Shared button style matching the original Island look
export const ControlButton = styled.div<{ active: boolean; buttonType: ButtonType }>`
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 6px 11px;
	height: 18px;

	border-radius: ${({ buttonType }) => {
		switch (buttonType) {
			case ButtonType.LEFT:
				return '12px 0 0 12px';
			case ButtonType.RIGHT:
				return '0 12px 12px 0';
			case ButtonType.CENTER:
				return '0';
			case ButtonType.SINGLE:
				return '12px';
			default:
				return '12px';
		}
	}};
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
	background: ${({ theme }) => theme.gray[0]};

	&:hover {
		background: ${({ theme, active }) => (active ? theme.gray[100] : theme.gray[0])};
	}
	&:active {
		background: ${({ theme, active }) => (active ? theme.gray[200] : theme.gray[0])};
	}
`;

export const VerticalLine = styled.div`
	width: 1px;
	height: 30px;
	background: ${({ theme }) => theme.gray[400]};
`;

export const IconWrapper = styled.div`
	pointer-events: none;
	margin-top: 1px;
`;

export const Label = styled.div<{ color: string }>`
	font-size: 14px;
	font-weight: 400;
	color: ${({ color }) => color};
`;
